// import FoodDelivery from "../assets/portfolio/FoodDelivery.png";
// import demo from '../assets/portfolio/demo.jpg'
// import AddEmployee from '../assets/portfolio/AddEmployee.webp'
// import weatherApp from '../assets/portfolio/weatherApp.webp'
import Foody from "../assets/portfolio/Foody.webp"
// import AddEmployee from '../assets/portfolio/AddEmployee.png'
// import weatherApp from '../assets/portfolio/weatherApp.png'
// import Foody from "../assets/portfolio/Foody.png"
// import TicTacToe from '../assets/portfolio/TicTacToe.webp'
import PixieVite from '../assets/portfolio/PixieVite.webp'
import Pokemon from '../assets/portfolio/pokemon_app.jpg'
// import ProjectVault from "../assets/portfolio/ProjectVault.png"
import VroomAI from "../assets/portfolio/VroomAI.jpg"
import Pdf_merger from "../assets/portfolio/Pdf_merger.png"
import MoneyMate from "../assets/portfolio/MoneyMate.png"

export const portfolios = [
    {
        id: 1,
        src: MoneyMate,
        codeLink: "https://github.com/utkarsh2004git/MoneyMate.git",
        viewLink: "https://money-mate-five-orcin.vercel.app/",
        project: "MoneyMate",
        technology: [
            "React",
            "Spring Boot",
            "JWT",
            "SQL",
            "Tailwind CSS"
        ]
    },
    {
        id: 2,
        src: Foody,
        codeLink: "https://foody-delivery.onrender.com",
        viewLink: "https://foody-delivery.onrender.com",
        project: "Foody-app",
        technology: ["React","NodeJs","Tailwind","Express","MongoDB"]
    },
    {
        id: 3,
        src: VroomAI,
        codeLink: "https://vroom-ai.vercel.app/",
        viewLink: "https://vroom-ai.vercel.app/",
        project: "VroomAI",
        technology: ["NextJS","Tailwind","GeminiAI","Supabase"]
    },
    {
        id: 4,
        src: PixieVite,
        codeLink: "https://pixie-vite.vercel.app/",
        viewLink: "https://pixie-vite.vercel.app/",
        project: "PixieVite",
        technology: ["React","NodeJs","Tailwind","Express","MongoDB"]
    },
    {
        id: 5,
        src: Pdf_merger,
        codeLink: "https://pdf-merger-u.vercel.app/",
        viewLink: "https://pdf-merger-u.vercel.app/",
        project: "PDF Merger",
        technology: ["NextJS","Tailwind","Copilot","Clerk"]
    },
    {
        id: 6,
        src:Pokemon,
        codeLink: "https://utkarsh2004git.github.io/my-pokemon-app/",
        viewLink: "https://utkarsh2004git.github.io/my-pokemon-app/",
        project: "Pokemon-App",
        technology: ["React","Tailwind"]
    },
    // {
    //     id:8,
    //     src: ProjectVault,
    //     codeLink: "https://project-vault-chi.vercel.app/",
    //     viewLink: "https://project-vault-chi.vercel.app/",
    //     project: "ProjectVault",
    //     technology: ["Next","NextAuth","Sentry.io","Tailwind","Sanity"]
    // },
    // {
    //     id: 3,
    //     src: weatherApp,
    //     codeLink: "https://github.com/utkarsh2004git/Weather_App/",
    //     viewLink: "https://utkarsh-react-weather-app.netlify.app/",
    //     project: "Weather-App",
    //     technology: ["React","NodeJs","Tailwind","Express","MongoDB"]
    // },
    // {
    //     id: 5,
    //     src: AddEmployee,
    //     codeLink: "https://github.com/utkarsh2004git/Todo-theme-change/",
    //     viewLink: "https://utkarshshahare.me/Todo-theme-change/public/",
    //     project: "Add-Employee",
    //     technology: ["React","Tailwind"]
    // },


    // {
    //     id: 6,
    //     src: FoodDelivery,
    //     codeLink: "https://github.com/utkarsh2004git/webdev_projects/tree/main/FoodDelivery",
    //     viewLink: "https://utkarsh2004git.github.io/webdev_projects/FoodDelivery/",
    //     project: "Food-Delivery",
    //     technology: ["HTML","CSS"]
    // },

    // {
    //     id: 7,
    //     src: TicTacToe,
    //     codeLink: "https://github.com/utkarsh2004git/Tic-Tac-Toe",
    //     viewLink: "https://utkarsh2004git.github.io/Tic-Tac-Toe/public/",
    //     project: "Tic-Tac-Toe",
    //     technology:["HTML","CSS","JS"]
    // },


];